import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  empty: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '3rem',
    padding: ({ empty }) => (empty ? '0' : '0 2rem 0.5rem 2rem'),
    overflowX: 'hidden',
    overflowY: 'auto',

    [theme.breakpoints.down('lg')]: {
      padding: '0.5rem 1rem'
    }
  },

  loading: {
    position: 'relative',
    left: '45%',
    marginTop: '4rem'
  },

  emptyTitle: {
    display: 'revert !important',
    textAlign: 'center',
    color: 'rgb(127, 132, 135)',
    opacity: '0.7',
    fontSize: `${theme.size.sm} !important`,
    borderBottom: 'none !important'
  },

  bottomPad: {
    position: 'absolute',
    bottom: '0',
    background: 'white',
    width: '100%',
    height: '0.5rem'
  }
}))

export default useStyles
